//cardNumber
export const validateCardNumber = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('Please enter your bank card number'))
  }
  if (value) {
    setTimeout(() => {
      var reg = /^[4|5|6]\d{12,15}$/
      var reg2 = /^[3][7]\d{11,14}$/
      if (!reg.test(value) && !reg2.test(value)) {
        callback(new Error('Please enter a valid bank card number！'))
      } else {
        callback()
      }
    }, 500)
  }
}

//email
export const validateEmail = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('Please enter your Email'))
  }
  if (value) {
    setTimeout(() => {
      // Updated regex to properly handle hyphens and be more standard
      var reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!reg.test(value)) {
        callback(new Error('Please enter a valid Email！'))
      } else {
        callback()
      }
    }, 500)
  }
}

//cvv
export const validateCVV = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('Please enter your CVV'))
  }
  if (value) {
    setTimeout(() => {
      var reg = /^\d{3,4}$/
      if (!reg.test(value)) {
        callback(new Error('Please enter a valid CVV！'))
      } else {
        callback()
      }
    }, 500)
  }
}

export const downAPP = (contentId, paddingBottom) => {
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  if (document.documentElement.clientWidth < 450 && isiOS) {
    document.getElementById(contentId).style.paddingBottom = paddingBottom
  }
}

export const downAPPBottom = (contentId, paddingBottom) => {
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  if (document.documentElement.clientWidth < 450 && isiOS) {
    document.getElementById(contentId).style.bottom = paddingBottom
  }
}



// WEBPACK FOOTER //
// ./src/views/public/validator.js